const normalizePathSegment = (segment: string): string => segment.replace(/^\/+|\/+$/g, '');

export const APP_ROUTE_PATHS = {
  home: '',
  prompts: 'prompts',
  phoneNumbers: 'phone-numbers',
  error: 'error',
  wallboards: 'wallboards',
} as const;

export const SELF_SERVICE_ROUTE_PATHS = {
  root: '',
  edit: 'edit/:flowName/id/:keyword',
  auditLog: 'audit-log',
  help: 'help',
} as const;

export const PHONE_NUMBERS_ROUTE_PATHS = {
  root: '',
  create: 'create',
  edit: 'edit/:phone-number',
  auditLog: 'audit-log',
} as const;

export const WALLBOARD_ROUTE_PATHS = {
  staffStats: 'staff-stats',
  staffTvStats: 'staff-tv-stats/:key',
  agentStats: 'agent-stats',
  agentTvStats: 'agent-tv-stats/:key',
} as const;

const toAbsolutePath = (...segments: string[]): string => {
  const normalized = segments.map((segment) => normalizePathSegment(segment)).filter((segment) => segment.length > 0);

  return normalized.length === 0 ? '/' : `/${normalized.join('/')}`;
};

export const APP_ROUTE_PATTERNS = {
  home: toAbsolutePath(APP_ROUTE_PATHS.home),
  prompts: toAbsolutePath(APP_ROUTE_PATHS.prompts),
  promptsAuditLog: toAbsolutePath(APP_ROUTE_PATHS.prompts, SELF_SERVICE_ROUTE_PATHS.auditLog),
  promptsHelp: toAbsolutePath(APP_ROUTE_PATHS.prompts, SELF_SERVICE_ROUTE_PATHS.help),
  promptsEdit: toAbsolutePath(APP_ROUTE_PATHS.prompts, SELF_SERVICE_ROUTE_PATHS.edit),
  phoneNumbers: toAbsolutePath(APP_ROUTE_PATHS.phoneNumbers),
  phoneNumbersCreate: toAbsolutePath(APP_ROUTE_PATHS.phoneNumbers, PHONE_NUMBERS_ROUTE_PATHS.create),
  phoneNumbersAuditLog: toAbsolutePath(APP_ROUTE_PATHS.phoneNumbers, PHONE_NUMBERS_ROUTE_PATHS.auditLog),
  phoneNumbersEdit: toAbsolutePath(APP_ROUTE_PATHS.phoneNumbers, PHONE_NUMBERS_ROUTE_PATHS.edit),
  wallboardsStaffStats: toAbsolutePath(APP_ROUTE_PATHS.wallboards, WALLBOARD_ROUTE_PATHS.staffStats),
  wallboardsStaffTvStats: toAbsolutePath(APP_ROUTE_PATHS.wallboards, WALLBOARD_ROUTE_PATHS.staffTvStats),
  wallboardsAgentStats: toAbsolutePath(APP_ROUTE_PATHS.wallboards, WALLBOARD_ROUTE_PATHS.agentStats),
  wallboardsAgentTvStats: toAbsolutePath(APP_ROUTE_PATHS.wallboards, WALLBOARD_ROUTE_PATHS.agentTvStats),
  error: toAbsolutePath(APP_ROUTE_PATHS.error, ':errorCode'),
} as const;
